module.exports = __webpack_public_path__ + "media/images/Wireframe-Circles-889816a0.png";